var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cs-artisticalLabel-container"},[_c('div',{staticClass:"cs-artisticalLabel-background"},[_vm._v("\n    "+_vm._s(_vm.backgroundText)+"\n  ")]),_vm._v(" "),_c('span',{staticClass:"cs-artisticalLabel-text"},[_vm._v(_vm._s(_vm.labelText))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-59e62c03","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/artisticalLabel.vue
// module id = +K/V
// module chunks = 0